import { render, staticRenderFns } from "./invoiceOpen.vue?vue&type=template&id=2e253393&scoped=true"
import script from "./invoiceOpen.vue?vue&type=script&lang=js"
export * from "./invoiceOpen.vue?vue&type=script&lang=js"
import style0 from "./invoiceOpen.vue?vue&type=style&index=0&id=2e253393&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e253393",
  null
  
)

export default component.exports